import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    快速导航: [
      { label: '首页', to: '/' },
      { label: '分类浏览', to: '/category/rexue' },
      { label: '热门推荐', to: '/#featured' },
      { label: '最新更新', to: '/#latest' },
    ],
    漫画分类: [
      { label: '热血漫画', to: '/category/rexue' },
      { label: '恋爱漫画', to: '/category/lianai' },
      { label: '悬疑漫画', to: '/category/xuanyi' },
      { label: '奇幻漫画', to: '/category/qihuan' },
    ],
    关于我们: [
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about#testimonials' },
      { label: '联系我们', to: '/about#contact' },
      { label: 'APP下载', to: '/#download' },
    ],
  };

  return (
    <footer className="bg-secondary-950 text-foreground-50" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-accent-400">
                jm漫画
              </span>
            </Link>
            <p className="text-sm text-foreground-200 leading-relaxed mb-4">
              jm漫画是深受用户喜爱的在线漫画阅读平台，提供海量正版漫画资源。每日更新最新章节，支持多端畅读，是漫画爱好者的首选平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-50/10 flex items-center justify-center text-foreground-50 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-50/10 flex items-center justify-center text-foreground-50 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-50/10 flex items-center justify-center text-foreground-50 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-300">
            &copy; {new Date().getFullYear()} jm漫画 版权所有 | 本站所有漫画均为正版授权内容
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-300">
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}